var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    {
      attrs: { title: "Performance por Transportadora", loading: _vm.loading }
    },
    [
      _c(
        "sc-grid",
        {
          attrs: {
            name: _vm.$options.name,
            data: _vm.reportData.items,
            total: _vm.reportData.total,
            "default-filters": _vm.defaultFilters
          },
          on: {
            submit: _vm.config,
            pagination: _vm.config,
            sorting: _vm.config
          },
          scopedSlots: _vm._u([
            {
              key: "filters",
              fn: function(ref) {
                var filters = ref.filters
                return [
                  _c("sc-report-provider-filters", {
                    attrs: { filters: filters }
                  })
                ]
              }
            },
            {
              key: "table-columns",
              fn: function(ref) {
                var props = ref.props
                return [
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "shipping_first_name",
                        label: "Nome",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.shipping_first_name) +
                          " " +
                          _vm._s(props.row.shipping_last_name) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "delivery_method_name",
                        label: "Método de entrega",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.delivery_method_name) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "estimated_delivery_date_lp_iso",
                        label: "Estimativa de entrega",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(
                              props.row.estimated_delivery_date_lp_iso,
                              "DD/MM/YYYY"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "delivered_date_iso",
                        label: "Data de entrega",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm._f("date")(
                              props.row.delivered_date_iso,
                              "DD/MM/YYYY"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "delivery_method_name",
                        label: "Performance",
                        sortable: ""
                      }
                    },
                    [
                      !props.row.delivered_late_lp
                        ? _c("span", { staticClass: "tag is-primary" }, [
                            _vm._v("No prazo")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      props.row.delivered_late_lp
                        ? _c("span", { staticClass: "tag is-danger" }, [
                            _vm._v("Atrasado")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "sc-table-column",
                    {
                      attrs: {
                        field: "shipping_state",
                        label: "UF",
                        sortable: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(props.row.shipping_state) +
                          "\n      "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm.reportData.total
            ? _c(
                "template",
                { attrs: { slot: "after-filters" }, slot: "after-filters" },
                [
                  _c(
                    "div",
                    { staticClass: "box" },
                    [_c("sc-chart-provider-ship-state")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "box" },
                    [_c("sc-chart-provider-ship-state-percent")],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "box" }, [
                    _c("div", { staticClass: "columns" }, [
                      _c(
                        "div",
                        { staticClass: "column is-12-mobile" },
                        [_c("sc-chart-provider-ship-orders")],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "column is-12-mobile is-one-third-widescreen"
                        },
                        [_c("sc-chart-provider-orders")],
                        1
                      )
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.reportData.total
            ? _c(
                "template",
                { attrs: { slot: "before-table" }, slot: "before-table" },
                [
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c("sc-button", {
                        attrs: {
                          theme: "primary",
                          loading: _vm.exportLoading,
                          text: "Exportar para o Excel",
                          icon: "file-excel"
                        },
                        on: {
                          click: function($event) {
                            _vm.exportPerformanceProviderReport(
                              _vm.reportConfig
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bc81a28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bc81a28","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/reports/pages/provider/PageReportProvider.vue
// module id = null
// module chunks = 